<template>
  <div class="backgroud-white cs-courseActivationEditor" v-loading="isLoading">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :rules="rules" :model="model" label-width="160px">
        <el-form-item :label="actualTimeLabel" prop="actualTime">
          <el-col :span="11">
            <el-time-picker size="small" v-model="model.actualStartTime" align="center"
              placeholder="开始时间" :clearable="false" format="HH:mm"
              @change="onTimeChange('actualTime')"></el-time-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11"> 
            <el-time-picker size="small" v-model="model.actualEndTime" align="center"
              placeholder="结束时间" :clearable="false" format="HH:mm"
              @change="onTimeChange('actualTime')"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item :label="breakTimeLabel" prop="breakTime">
          <el-col :span="11">
            <el-time-picker size="small" v-model="model.breakStartTime" align="center"
              placeholder="开始时间" :clearable="false" format="HH:mm"
              @change="onTimeChange('breakTime')"></el-time-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11"> 
            <el-time-picker size="small" v-model="model.breakEndTime" align="center"
              placeholder="结束时间" :clearable="false" format="HH:mm"
              @change="onTimeChange('breakTime')"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="model.content" type="textarea" rows="3" placeholder="上课内容" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="免计签到" prop="skipSignIn">
          <el-checkbox v-model="model.isNotSignIn" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="视频免费" prop="isFreeVideo">
          <el-checkbox v-model="model.isFreeVideo" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="课程类型" prop="courseCategory">
          <el-select class="input-width" v-model="model.courseCategory" placeholder="请选择课程类型">
            <el-option v-for="item in courseCategoryList" :key="item.Key" :label="item.Value"
              :value="item.Key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间戳是否一致" prop="timestampStatus">
          <el-select class="input-width" v-model="model.timestampStatus" placeholder="请选择时间戳是否一致">
            <el-option v-for="item in GLOBAL.timestampStatusType.getOptions()" :key="item.value" :label="item.desc"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否开启摄像头" prop="cameraStatus">
          <el-select class="input-width" v-model="model.cameraStatus" placeholder="请选择是否开启摄像头">
            <el-option v-for="item in GLOBAL.cameraStatusType.getOptions()" :key="item.value" :label="item.desc"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无速成元素" prop="speedupElementStatus"
          v-if="course.CourseActivationType === GLOBAL.enumCourseActivationType.EmailVideo">
          <el-select class="input-width" v-model="model.speedupElementStatus" placeholder="请选择有无速成元素">
            <el-option v-for="item in GLOBAL.speedupElementStatusType.getOptions()" :key="item.value" :label="item.desc"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="6">
          <el-button :disabled="isLoading" type="primary" @click="save()">保存</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small {
  padding-top: 30px;
  padding-bottom: 20px;
}

.cs-courseActivationEditor {
  /deep/ .el-range-separator {
    z-index: 99;
  }

  /deep/ .el-date-editor.el-input{
    width: auto;
  }

  .el-form-item {
    margin-bottom: 10px;

    .line{
      text-align: center;
    }

    /deep/ .el-form-item__content{
      text-align: left;
    }

    /deep/ .el-form-item__error{
      top: 42px;
    }
  }
}
</style>

<script>
import { saveCourseActivationDetail } from "../../service/signInManage.service";
import { getCourseCategoryList } from "../../service/common.service.js";

let moment = require("moment");

export default {
  props: {
    course: Object,
  },
  data() {
    let _self = this;
    let actualTimeValidator = (rule, value, callback) => {
      if (!this.model.actualStartTime && !this.model.actualEndTime) {
        return callback(new Error("请选择课节开始结束时间"));
      }
      if (!this.model.actualStartTime) {
        return callback(new Error("请选择课节开始时间"));
      }
      if (!this.model.actualEndTime) {
        return callback(new Error("请选择课节结束时间"));
      }
      
      // 统一提取时间部分进行比较
      let baseDate = moment().format('YYYY-MM-DD');
      let startTimeStr = this.getTimeString(this.model.actualStartTime);
      let endTimeStr = this.getTimeString(this.model.actualEndTime);
      let startMoment = moment(`${baseDate} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
      let endMoment = moment(`${baseDate} ${endTimeStr}`, 'YYYY-MM-DD HH:mm');
      
      if (endMoment.isSameOrBefore(startMoment)) {
        return callback(new Error("课节开始时间必须小于结束时间"));
      }
      
      return callback();
    };

    let breakTimeValidator = (rule, value, callback) => {
      if (this.model.breakStartTime || this.model.breakEndTime) {
        if (!this.model.breakStartTime) {
          return callback(new Error("请选择课间休息开始时间"));
        }
        if (!this.model.breakEndTime) {
          return callback(new Error("请选择课间休息结束时间"));
        }
        
        // 统一提取时间部分进行比较
        let baseDate = moment().format('YYYY-MM-DD');
        let startTimeStr = this.getTimeString(this.model.breakStartTime);
        let endTimeStr = this.getTimeString(this.model.breakEndTime);
        let startMoment = moment(`${baseDate} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
        let endMoment = moment(`${baseDate} ${endTimeStr}`, 'YYYY-MM-DD HH:mm');
        
        if (endMoment.isSameOrBefore(startMoment)) {
          return callback(new Error("课间休息开始时间必须小于结束时间"));
        }
      }

      return callback();
    };

    return {
      model: {
        actualStartTime: null,
        actualEndTime:null,
        breakStartTime: null,
        breakEndTime:null,
        content: "",
        isNotSignIn: false,
        courseCategory: "",
        timestampStatus: 0,
        cameraStatus: 0,
        speedupElementStatus: 0,
        actualStartTimeText: "",
        actualEndTimeText: "",
        courseMinutes: 0,
        breakStartTimeText: "",
        breakEndTimeText: "",
        breakMinutes: 0,
        isFreeVideo: false,
      },
      actualTimeLabel: "课程时长",
      breakTimeLabel: "课间休息",
      courseCategoryList: [],
      showError: false,
      errorMessage: "",

      isLoading: false,
      rules: {
        actualTime: [
          {
            validator: actualTimeValidator,
            trigger: "blur"
          }
        ],
        breakTime: [
          {
            validator: breakTimeValidator,
            trigger: "blur"
          }
        ],
      }
    };
  },
  components: {},
  created() {
    this.isLoading = true;
    getCourseCategoryList(1).then(result => {
      if (!!result && result.success) {
        let list = result.data;
        list.splice(list.findIndex(item => item.Key == 2), 1)
        this.courseCategoryList = list;
      }
      this.init();
      this.isLoading = false;
    });
  },
  methods: {
    init() {
      if (this.course) {
        let date = moment().format('YYYY/MM/DD');
        this.model.courseMinutes = this.course.CourseMinutes;
        this.model.breakMinutes = this.course.BreakMinutes;
        this.model.actualStartTimeText = this.course.ActualStartTimeText;
        this.model.actualEndTimeText = this.course.ActualEndTimeText;
        this.model.breakStartTimeText = this.course.BreakStartTimeText;
        this.model.breakEndTimeText = this.course.BreakEndTimeText;
        if (this.course.ActualStartTimeText && this.course.ActualEndTimeText) {
          this.model.actualStartTime = this.getDate(date, this.course.ActualStartTimeText);
          this.model.actualEndTime = this.getDate(date, this.course.ActualEndTimeText);
          this.model.courseMinutes = this.getMinutes(this.model.actualStartTime, this.model.actualEndTime);
        } else {
          this.model.actualStartTime = null;
          this.model.actualEndTime = null;
        }
        if (this.course.BreakStartTimeText && this.course.BreakEndTimeText) {
          this.model.breakStartTime = this.getDate(date, this.course.BreakStartTimeText);
          this.model.breakEndTime = this.getDate(date, this.course.BreakEndTimeText);
          this.model.breakMinutes = this.getMinutes(this.model.breakStartTime, this.model.breakEndTime);
        } else {
          this.model.breakStartTime = null;
          this.model.breakEndTime = null;
        }

        this.model.content = this.course.Content;
        this.model.isNotSignIn = this.course.IsNotSignIn;
        this.model.isFreeVideo = this.course.IsFreeVideo;
        this.model.courseCategory = this.course.CourseCategory;
        this.model.timestampStatus = this.course.TimestampStatus;
        this.model.cameraStatus = this.course.CameraStatus;
        this.model.speedupElementStatus = this.course.SpeedupElementStatus;
      } else {
        this.model.actualStartTime = null;
        this.model.actualEndTime = null;
        this.model.breakStartTime = null;
        this.model.breakEndTime = null;
        this.model.content = "";
        this.model.isNotSignIn = false;
        this.model.isFreeVideo = false;
        this.model.courseCategory = "";
        this.model.timestampStatus = 0;
        this.model.cameraStatus = 0;
        this.model.speedupElementStatus = 0;
        this.model.courseMinutes = 0;
        this.model.breakMinutes = 0;
        this.model.actualStartTimeText = "";
        this.model.actualEndTimeText = "";
        this.model.breakStartTimeText = "";
        this.model.breakEndTimeText = "";
      }
      this.setLabel();
    },
    onTimeChange(name) {
      switch (name) {
        case 'actualTime': {
          // 标准化时间对象
          let startTime = this.normalizeTimeObject(this.model.actualStartTime);
          let endTime = this.normalizeTimeObject(this.model.actualEndTime);
          
          // 只有当开始时间和结束时间都存在时才计算
          if (startTime && endTime) {
            this.model.courseMinutes = this.getMinutes(startTime, endTime);
          } else {
            this.model.courseMinutes = 0;
          }
          break;
        }
        case 'breakTime': {
          // 标准化时间对象
          let startTime = this.normalizeTimeObject(this.model.breakStartTime);
          let endTime = this.normalizeTimeObject(this.model.breakEndTime);
          
          // 只有当开始时间和结束时间都存在时才计算
          if (startTime && endTime) {
            this.model.breakMinutes = this.getMinutes(startTime, endTime);
          } else {
            this.model.breakMinutes = 0;
          }
          break;
        }
      }
      this.setLabel();
    },
    setLabel() {
      this.actualTimeLabel = `课程时长(${this.model.courseMinutes}分钟)`;
      this.breakTimeLabel = `课间休息(${this.model.breakMinutes}分钟)`;
    },
    save() {
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }

        this.isLoading = true;

        this.model.actualStartTimeText = this.getTimeString(this.model.actualStartTime);
        this.model.actualEndTimeText = this.getTimeString(this.model.actualEndTime);
        this.model.breakStartTimeText = "";
        this.model.breakEndTimeText = "";
        if (this.model.breakStartTime) {
          this.model.breakStartTimeText = this.getTimeString(this.model.breakStartTime);
        }
        if (this.model.breakEndTime) {
          this.model.breakEndTimeText = this.getTimeString(this.model.breakEndTime);
        }

        saveCourseActivationDetail(
          this.course.CourseActivationId,
          this.model.actualStartTimeText,
          this.model.actualEndTimeText,
          this.model.breakStartTimeText,
          this.model.breakEndTimeText,
          this.model.content,
          this.model.courseCategory,
          !this.model.isNotSignIn,
          this.model.timestampStatus,
          this.model.cameraStatus,
          this.model.speedupElementStatus,
          this.model.isFreeVideo
        )
          .then(result => {
            if (result && result.success) {
              this.$message.success("保存成功");
              this.$emit("success", this.model);
            } else {
              this.errorMessage = result.message;
              this.showError = true;
            }
            this.isLoading = false;
            this.submitBtnDisable = false;
          })
          .catch(() => {
            this.isLoading = false;
            this.submitBtnDisable = false;
          });
      }
    },
    getTimeString(time) {
      if (!time) {
        return "";
      }
      return moment(time).format("HH:mm");
    },
    getMinutes(startTime, endTime) {
      if (startTime && endTime) {
        // 提取时间部分（小时和分钟），统一使用今天的日期进行计算
        let baseDate = moment().format('YYYY-MM-DD');
        let startTimeStr = this.getTimeString(startTime);
        let endTimeStr = this.getTimeString(endTime);
        
        // 使用统一的基准日期创建新的时间对象
        let startMoment = moment(`${baseDate} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
        let endMoment = moment(`${baseDate} ${endTimeStr}`, 'YYYY-MM-DD HH:mm');
        
        // 如果时间对象无效，返回0
        if (!startMoment.isValid() || !endMoment.isValid()) {
          console.warn('Invalid time objects:', { startTime, endTime });
          return 0;
        }
        
        let diffMinutes = endMoment.diff(startMoment, 'minutes');
        
        // 如果结束时间小于开始时间，可能是跨天的情况，需要加上24小时
        if (diffMinutes < 0) {
          diffMinutes = diffMinutes + 24 * 60;
        }
        
        return diffMinutes;
      }
      return 0;
    },
    getDate(dateString, timeString) {
      if (timeString) {
        let str = `${dateString} ${timeString}`;
        return moment(str).toDate();
      }
      return null;
    },
    // 安全地处理时间选择器返回的时间对象
    normalizeTimeObject(timeObj) {
      if (!timeObj) return null;
      
      // 如果已经是Date对象，检查是否有效
      if (timeObj instanceof Date) {
        if (isNaN(timeObj.getTime())) {
          console.warn('Invalid Date object:', timeObj);
          return null;
        }
        return timeObj;
      }
      
      // 如果是字符串，尝试解析
      if (typeof timeObj === 'string') {
        let momentObj = moment(timeObj);
        if (momentObj.isValid()) {
          return momentObj.toDate();
        }
      }
      
      console.warn('Unable to normalize time object:', timeObj);
      return null;
    },
  },
  watch: {
    course: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/courseActivationEditor.vue